import { VStack, Text } from '@vimeo/bokeh';
import { Filter, SearchMagnifierFilled } from '@vimeo/bokeh-icons';

import { T } from '../../translations';

type Props = {
  isFilter: boolean;
  onClearClick?: () => void;
};

export const FilteredEmptyState = ({ isFilter, onClearClick }: Props) => {
  let NoMatchIcon = isFilter ? <Filter boxSize="lg" /> : <SearchMagnifierFilled boxSize="lg" />;
  let clearText = isFilter ? T.ClearFilters : T.DifferentSearch;

  return (
    <VStack
      px={{ base: 200, md: 300 }}
      flexGrow={1}
      align="center"
      justify="center"
      data-testid="comments-no-match-placeholder"
    >
      {NoMatchIcon}
      <Text variant="heading-md" color="text-primary">
        {T.NoMatchingResults}
      </Text>
      <Text
        as={isFilter ? 'u' : 'text'}
        variant="body-sm"
        fontSize="14px"
        fontWeight="350"
        cursor={isFilter ? 'pointer' : 'default'}
        color="text-secondary"
        onClick={() => {
          onClearClick?.();
        }}
      >
        {clearText}
      </Text>
    </VStack>
  );
};
